import { SET_SERACH_TEXT } from "../../Constants/reduxKeys";

export function setSearchText(text) {
  return {
    type: SET_SERACH_TEXT,
    payload: text,
  };
};